'use strict'

import React, { PureComponent } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'

import './BackToStore.scss'

class BackToStore extends PureComponent {
  render () {
    return (
      <div className='backtostore'>
        { this.props.searchTerm === null &&
          <a href='/stores/' tabIndex={0} className='bts-link'>
            <span className='icon-UIE-Controls-Chevron-Left' aria-hidden='true' />
            <span className='bts-text'>Back to store locator</span>
          </a>
        }
        { this.props.searchTerm !== null &&
          <Link to={'/stores/search/' + this.props.searchTerm} tabIndex={0} className='bts-link'>
            <span className='icon-UIE-Controls-Chevron-Left' aria-hidden='true' />
            <span className='bts-text'>Back to store list</span>
          </Link>
        }
      </div>
    )
  }
}

BackToStore.propTypes = {
  searchTerm: PropTypes.string
}

export default BackToStore



// WEBPACK FOOTER //
// ./src/components/BackToStore/BackToStore.jsx